var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 17,
    viewBox: "0 0 85 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_996_1794",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 85,
    height: 17
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip0_8_162"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M85 0.488525H0V17.0001H85V0.488525Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_996_1794)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.73154 0.488525L0 3.18793H6.19143V16.7589H8.89245V3.18793H13.3523L15.0839 0.488525H1.73154Z",
    fill: "#3A85F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.6353 5.61074C15.7109 5.61074 14.8154 5.84708 14.0195 6.29885V5.61074H11.3201V16.7588H14.0195V10.926C14.0195 9.4838 15.1932 8.31015 16.6353 8.31015H18.3283L20.0598 5.60913H16.6353V5.61074Z",
    fill: "#3A85F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M39.6792 5.61401L36.2209 11.6141L32.7514 5.61401H29.6469L36.2209 17.0001L42.7838 5.61401H39.6792Z",
    fill: "#3A85F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M28.7883 7.23949L28.7835 7.23466C28.5954 7.0562 28.3671 6.84881 28.105 6.6607L28.0761 6.64141C27.724 6.39542 27.3623 6.19284 26.97 6.02564C26.777 5.94043 26.5777 5.8729 26.3783 5.81985C26.1918 5.75714 25.9764 5.71213 25.7304 5.67997C25.5423 5.64621 25.3349 5.62209 25.1178 5.61084H24.8429C23.3059 5.61084 21.9779 6.15908 20.8975 7.23949C19.8171 8.31989 19.2689 9.64789 19.2689 11.1849C19.2689 12.3891 19.6242 13.4888 20.3268 14.4567C21.4779 15.984 22.9972 16.7589 24.8429 16.7589H30.417V11.1849C30.417 9.64789 29.8687 8.31989 28.7883 7.23949ZM27.732 14.074L24.8429 14.0708C24.039 14.0708 23.3734 13.7959 22.8091 13.2332C22.2432 12.656 21.9683 11.9872 21.9683 11.1849C21.9683 10.3826 22.2432 9.71542 22.8091 9.14788C23.3702 8.57553 24.0358 8.29899 24.8429 8.29899C25.65 8.29899 26.3156 8.57713 26.8799 9.1511C27.4523 9.7122 27.7288 10.3778 27.7288 11.1849L27.732 14.074Z",
    fill: "#3A85F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M57.522 0.488525H54.8242V16.7203H57.522V0.488525Z",
    fill: "#3A85F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M85 0.488525H82.3022V6.41951C82.0578 6.27159 81.8054 6.13976 81.5401 6.02561C81.3472 5.9404 81.1478 5.87287 80.9484 5.81982C80.762 5.75711 80.5465 5.7121 80.3005 5.67994C80.1124 5.64618 79.905 5.62206 79.688 5.61081H79.4131C77.876 5.61081 76.548 6.15905 75.4676 7.23946C74.3872 8.31986 73.839 9.64786 73.839 11.1849C73.839 12.3891 74.1943 13.4888 74.8969 14.4566C76.048 15.984 77.5674 16.7589 79.4131 16.7589H84.9871V16.722H85V0.488525ZM77.3793 13.2315C76.8133 12.6544 76.5384 11.9855 76.5384 11.1833C76.5384 10.381 76.8133 9.71378 77.3793 9.14625C77.9404 8.57389 78.606 8.29735 79.4131 8.29735C80.2201 8.29735 80.8857 8.57549 81.4501 9.14946C82.0224 9.71056 82.299 10.3762 82.299 11.1833L82.3022 14.0724L79.4131 14.0692C78.6092 14.0692 77.9436 13.7942 77.3793 13.2315Z",
    fill: "#000FAF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M71.2506 16.7203H74.2265L66.6781 0.494873L59.1298 16.7203H62.1057L64.0527 12.5353H69.3036L71.2506 16.7203ZM65.3067 9.83588L66.6765 6.89049L68.0463 9.83588H65.3051H65.3067Z",
    fill: "#000FAF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M53.2164 11.1865C53.2164 11.0787 53.2132 10.971 53.2068 10.8649C53.2052 10.8344 53.2019 10.8038 53.2003 10.7749C53.1955 10.6977 53.1891 10.6189 53.181 10.5434C53.1778 10.5128 53.1746 10.4807 53.1698 10.4501C53.1601 10.3697 53.1489 10.291 53.1344 10.2122C53.1296 10.1881 53.1264 10.1639 53.1232 10.1398C53.1055 10.0385 53.0846 9.93725 53.0605 9.83757C52.8273 8.86649 52.3305 7.9967 51.5765 7.24266C50.4961 6.16226 49.1729 5.61401 47.644 5.61401C46.115 5.61401 44.7693 6.16226 43.6889 7.24266C42.6085 8.32307 42.0602 9.65107 42.0602 11.1865C42.0602 12.7219 42.6085 14.0499 43.6889 15.1303C44.7693 16.2107 46.1005 16.7589 47.644 16.7589H52.7341L51.0025 14.0611H47.5989C46.8192 14.0483 46.1632 13.7749 45.5989 13.2203C45.0346 12.6559 44.7597 11.9903 44.7597 11.1865C44.7597 10.3826 45.0346 9.71699 45.5989 9.15267C46.1713 8.58031 46.8401 8.30217 47.644 8.30217C48.4478 8.30217 49.1118 8.58835 49.6697 9.15427C49.8852 9.3665 50.0604 9.5948 50.1922 9.83757H47.6375L45.906 12.5354H53.0621C53.1521 12.1592 53.2019 11.7685 53.2132 11.3617C53.2148 11.3038 53.2164 11.2443 53.2164 11.1849V11.1865Z",
    fill: "#3A85F7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/Logo2.d684b6f9d51da95095666a84418faae8.svg";
export { ForwardRef as ReactComponent };